export type GpsShotQuality = "approximate" | "short-distance";

export const GPS_CLUBS = [
  { value: "driver", label: "Driver" },
  { value: "2w", label: "2 Wood" },
  { value: "3w", label: "3 Wood" },
  { value: "4w", label: "4 Wood" },
  { value: "5w", label: "5 Wood" },
  { value: "7w", label: "7 Wood" },
  { value: "9w", label: "9 Wood" },
  { value: "2h", label: "2 Hybrid" },
  { value: "3h", label: "3 Hybrid" },
  { value: "4h", label: "4 Hybrid" },
  { value: "5h", label: "5 Hybrid" },
  { value: "6h", label: "6 Hybrid" },
  { value: "7h", label: "7 Hybrid" },
  { value: "2i", label: "2 Iron" },
  { value: "3i", label: "3 Iron" },
  { value: "4i", label: "4 Iron" },
  { value: "5i", label: "5 Iron" },
  { value: "6i", label: "6 Iron" },
  { value: "7i", label: "7 Iron" },
  { value: "8i", label: "8 Iron" },
  { value: "9i", label: "9 Iron" },
  { value: "pw", label: "Pitching Wedge" },
  { value: "gw", label: "Gap Wedge" },
  { value: "sw", label: "Sand Wedge" },
  { value: "lw", label: "Lob Wedge" },
  { value: "putter", label: "Putter" },
] as const;
export type GpsClub = (typeof GPS_CLUBS)[number]["value"];
export function isGpsClub(value: unknown): value is GpsClub {
  return GPS_CLUBS.some((club) => club.value === value);
}
export function gpsClubLabel(value: GpsClub | null | undefined): string {
  return (
    GPS_CLUBS.find((club) => club.value === value)?.label ?? "Club not recorded"
  );
}

/** No raw coordinates cross this boundary. Distances are always metres. */
export interface SaveGpsShot {
  id: string;
  participantId: string;
  holeNumber: number;
  distanceMeters: number;
  startAccuracyMeters: number;
  endAccuracyMeters: number;
  methodVersion: "gps-endpoints-v1";
  club?: GpsClub | null | undefined;
}

export interface GpsShotMeasurement extends SaveGpsShot {
  roundId: string;
  quality: GpsShotQuality;
  createdAt: string;
}
